import { useMutation } from '@tanstack/react-query';
import { GET, GET_CUSTOMER_TEL } from '../../../../services';
import { openAlert } from '../../../../components/alert/hooks';

export const useGetTelephone = ({ getValues, reset }) => {
  const { mutate, isPending } = useMutation({
    mutationFn: async (tel) => {
      const response = await GET(GET_CUSTOMER_TEL(tel));
      return response.result;
    },
    onSuccess: (result) => {
      reset({
        ...getValues(),
        fullName: result.item.fullName,
      });
      openAlert({ model: 'message', type: 'success', message: 'ค้นหาเบอร์โทรศัพท์สำเร็จ' });
    },
    onError: () => {
      reset({
        ...getValues(),
        fullName: '',
      });
    },
  });

  return { mutate, loading: isPending };
};
